const API_BASE_URL_V1 = '/api/v1'

export const ENDPOINTS = {
    MARKET_DATA_V1: `${API_BASE_URL_V1}/market-data`,
    EVENTS_V1: `${API_BASE_URL_V1}/events`,
    PAGES_V1: `${API_BASE_URL_V1}/pages`,
}
